import React, { Component } from 'react'
import { Row, Col, Card } from 'react-bootstrap'
import AsideNavbar from '../components/navbars/AsideNavbar'
import GetReadyForExamSection from '../components/get_ready_for_exam/GetReadyForExamSection'


import * as Cookies from "es-cookie";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import { withRouter } from "react-router-dom";
import ScrollTopNavbar from '../components/navbars/ScrollTopNavbar'

import ReactGA from 'react-ga';
import { GoogleAnalyticsArray } from './GoogleAnalytics';

import { STUDENT_GLOBALS } from "../../utils/studentGlobals";
// Inline shimmer skeleton mirroring the get-ready-for-exam list cards.
const GetReadyExamShimmer = () => (
    <div className="py-4 px-3">
        <div className="rz-shimmer rz-skel-title" style={{ width: '32%', height: '24px' }}></div>
        <Row className="mt-3">
            {Array.from({ length: 6 }).map((_, i) => (
                <Col xl={6} lg={6} md={12} sm={12} key={i} className="mb-4">
                    <Card className="rz-skel-card border-0">
                        <div className="d-flex align-items-center">
                            <div className="rz-shimmer rz-skel-circle mr-3" style={{ width: '50px', height: '50px' }}></div>
                            <div style={{ flex: 1 }}>
                                <div className="rz-shimmer rz-skel-line" style={{ width: '65%' }}></div>
                                <div className="rz-shimmer rz-skel-line sm mb-0" style={{ width: '40%' }}></div>
                            </div>
                            <div className="rz-shimmer rz-skel-btn" style={{ width: '90px' }}></div>
                        </div>
                    </Card>
                </Col>
            ))}
        </Row>
    </div>
);


const FETCH_ISSTUDENTUSERVALID = gql` 
query($student_user_exam_id: Int!) {
    isStudentUserValid(student_user_exam_id: $student_user_exam_id){
        estatus
        current_plan_id
        expiry_date
        
        user_access_restictions
        module_restrictions
     }
}

`;

const FETCH_SCHEUDULE = gql` 
query($student_user_exam_id: Int!) {
    getScheduledExams(student_user_exam_id: $student_user_exam_id){
        id
        exam_type
        start_time
        end_time
        syllabus{
            subject_id
            subject_name
            chapters{
                id
                chapter
            }
        }
   }
}

`;

const FETCH_GETREADYEXAM = gql` 
query($student_user_exam_id: Int!, $page: Int) {
    getReadyForExamList(student_user_exam_id: $student_user_exam_id, page: $page){
        id
        sub_type
        exam_type
        class_id
        syllabus{
            subject_id
            subject_name
            chapters{
                id
                chapter
            }
        }
        exam_name
        exam_date
        save_exam_type
        is_completed
        timestamp
   }
}

`;


const UPDATE_STUDENT_ANALYTICS = gql`
  mutation(
    $params:AnalyticsStudents1  
    ) {
        studentAnalytics(
        params: $params
     )
  }
`;


class GetReadyForExam extends Component {
    constructor(props) {
        super(props)

        this.state = {
            toggled: "wrapper sidebar-enable",
            headerBottomImg: {
                Img: require('../../images/getreadyforexam.svg'),
                Title: "Get Ready For Exam",
                width: 200,
                helpImg: require('../../images/Ask_me_for_Help.gif')
            }
        }
    }
    componentDidMount = () => {

        this.addStudentAnalytics();

        const title = GoogleAnalyticsArray[0].GetReady_Exam;
        ReactGA.pageview('/student/get-ready-for-exam',["rizee"], title);
    }

    addStudentAnalytics = e => {
        let addStudentObj = ""

        addStudentObj = {
            exam_id: parseInt(Cookies.get("examid")),
            student_user_exam_id: parseInt(Cookies.get("student_user_exam_id")),
            analytics_module_page_id: 77,
            source :2

        }
        //console.log("addStudentObj",addStudentObj)

        this.submitpt(
            addStudentObj
        ).catch(error => {
            console.log("catch if error");
            console.log(error);
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message)
            });
        });
    }

    submitpt = async (
        params) => {
        await this.props.submitpt({
            variables: {
                params
            },
        });
    };
    menuToggler = () => {
        const toggled = Cookies.get("toggle");
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };
    render() {
        if (Cookies.get("studenttoken") == undefined)
            this.props.history.push("/student/login");
        const getScheduledExams = this.props.getScheduledExams;
        const loading1 = getScheduledExams.loading;
        const error1 = getScheduledExams.error;

        const getReadyForExamList = this.props.getReadyForExamList;
        const loading2 = getReadyForExamList.loading;
        const error2 = getReadyForExamList.error;

        const studentGlobals = this.props.studentGlobals;
        const loading3 = studentGlobals.loading;
        const error3 = studentGlobals.error;

        const isStudentUserValid = this.props.isStudentUserValid;
        const loading5 = isStudentUserValid.loading;
        const error5 = isStudentUserValid.error;

        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        if (error2 !== undefined) {
            alert("Server Error. " + error2.message);
            return null;
        }
        if (error3 !== undefined) {
            alert("Server Error. " + error3.message);
            return null;
        }
        if (error5 !== undefined) {
            alert("Server Error. " + error5.message);
            return null;
        }
        //console.log("getUserExplored", getReadyForExamList.getReadyForExamList);
        if (isStudentUserValid.isStudentUserValid != undefined) {
            if (isStudentUserValid.isStudentUserValid.estatus == 0) {
                Cookies.remove("token");
                Cookies.remove("username");
                Cookies.remove("refreshtoken");
                Cookies.remove("email");
                Cookies.remove("id");
                Cookies.remove("institutionid");
                Cookies.remove("userlevel");
                Cookies.remove("name");
                this.props.history.push("/student/login");
            }
            localStorage.removeItem('isStudentUserValid');
            localStorage.setItem(
                "isStudentUserValid",
                JSON.stringify(isStudentUserValid.isStudentUserValid)
            );
        }
        return (
            <div className={Cookies.get("toggle")}>
                <div className="student main-wrapper">
                    <div className="student header-area getreadyforexam-topnavbar">
                        <ScrollTopNavbar headerBottom={this.state.headerBottomImg} onClick={() => this.menuToggler()} />

                        {/* <ScrollTopNavbar headerBottom={this.state.headerBottomImg} onClick={() => this.menuToggler()} /> */}
                    </div>
                    <AsideNavbar onClick={() => this.menuToggler()} />
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper pt-0">
                        {(loading1 == true || loading2 == true || loading3 == true || loading5 == true) && (<GetReadyExamShimmer />)}
                        {
                            !loading1 && !loading2 && !loading3 && !loading5 && (
                                <GetReadyForExamSection
                                    getScheduledExams={getScheduledExams.getScheduledExams}
                                    getReadyForExamList={getReadyForExamList.getReadyForExamList}
                                    studentGlobals={studentGlobals.studentGlobals}
                                    isStudentUserValid={isStudentUserValid.isStudentUserValid}
                                />)
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(compose(
    graphql(FETCH_ISSTUDENTUSERVALID,
        {
            options: props => ({
                variables: {
                    student_user_exam_id: parseInt(Cookies.get("student_user_exam_id"))
                }
                ,
                // Shared cache entry; revalidated on navigation by utils/sessionValidity.
                fetchPolicy: 'cache-first'
            }), name: "isStudentUserValid"
        }),
    graphql(FETCH_SCHEUDULE,
        {
            options: props => ({
                variables: {
                    student_user_exam_id: parseInt(Cookies.get("student_user_exam_id"))
                }
                ,
                fetchPolicy: 'cache-and-network'
            }), name: "getScheduledExams"
        }),
    graphql(FETCH_GETREADYEXAM,
        {
            options: props => ({
                variables: {
                    student_user_exam_id: parseInt(Cookies.get("student_user_exam_id")),
                    page: 1
                },
                fetchPolicy: 'cache-and-network'
            }), name: "getReadyForExamList"
        }),
    graphql(STUDENT_GLOBALS,
        {
            options: props => ({
                variables: {
                    student_user_exam_id: parseInt(Cookies.get("student_user_exam_id"))
                },
                // Shared studentGlobals union; see utils/studentGlobals.
                fetchPolicy: 'cache-first'
            }), name: "studentGlobals"
        }),
        graphql(UPDATE_STUDENT_ANALYTICS, {
            name: "submitpt"
        }),
)(GetReadyForExam));
